var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgGoogle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_544",
    "data-name": "Group 544",
    transform: "translate(-3179 -11634)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_237",
    "data-name": "Rectangle 237",
    width: 24,
    height: 24,
    transform: "translate(3179 11634)",
    fill: "rgba(255,255,255,0)",
    opacity: 0.24
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_543",
    "data-name": "Group 543",
    transform: "translate(3179.732 11637.36)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_518",
    "data-name": "Group 518"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_115",
    "data-name": "Path 115",
    d: "M-11.75,5.778-.857-11.5H5.9v2.4L-3.487,5.778",
    transform: "translate(11.75 11.5)",
    fill: "#fbbc04"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_116",
    "data-name": "Path 116",
    d: "M2.261,5.778H-4.5V-11.5H2.261Z",
    transform: "translate(15.393 11.5)",
    fill: "#1a73e8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_117",
    "data-name": "Path 117",
    d: "M1.633-1.617A4.883,4.883,0,0,1-3.25,3.266V-6.5A4.883,4.883,0,0,1,1.633-1.617Z",
    transform: "translate(20.903 14.012)",
    fill: "#34a853"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_118",
    "data-name": "Path 118",
    d: "M1.633,3.266A4.883,4.883,0,0,1-3.25-1.617,4.883,4.883,0,0,1,1.633-6.5Z",
    transform: "translate(16.021 14.012)",
    fill: "#0d652d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_119",
    "data-name": "Path 119",
    d: "M1.256-1.244A3.756,3.756,0,0,1-2.5,2.512V-5A3.756,3.756,0,0,1,1.256-1.244Z",
    transform: "translate(20.153 5)",
    fill: "#1a73e8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_120",
    "data-name": "Path 120",
    d: "M1.256,2.512A3.756,3.756,0,0,1-2.5-1.244,3.756,3.756,0,0,1,1.256-5Z",
    transform: "translate(16.397 5)",
    fill: "#174ea6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_121",
    "data-name": "Path 121",
    d: "M-4.5-1.12A3.381,3.381,0,0,1-1.12-4.5a3.381,3.381,0,0,1,3.38,3.38,3.381,3.381,0,0,1-3.38,3.38A3.381,3.381,0,0,1-4.5-1.12Z",
    transform: "translate(4.876 4.5)",
    fill: "#ea4335"
  }))))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogle);
export default __webpack_public_path__ + "static/media/google.7eb770f0eaef24a958441a37c176acf4.svg";
export { ForwardRef as ReactComponent };